import {Component, Input, Type} from '@angular/core';
import {ModalWindowsTypes} from 'src/app/core/enums';
import {IGetClass, IModalWindow, ISetOptions} from 'src/app/utils/interfaces/modal-dialog.interface';
import { TranslateModule } from '@ngx-translate/core';


@Component({
    selector: 'asg-common-message-dialog',
    templateUrl: './common-message-dialog.component.html',
    styleUrls: ['./common-message-dialog.component.scss'],
    standalone: true,
    imports: [TranslateModule]
})
export class CommonMessageDialogComponent implements IModalWindow, ISetOptions, IGetClass {
  @Input() doNotShowAgainOk: () => void;
  @Input() ok: () => void;

  messageKey: string;
  interpolation: object = {};
  hasDoNotShowAgainButton: boolean = false;

  constructor() {
  }

  getWindowType(): Type<IModalWindow> {
    return CommonMessageDialogComponent;
  }

  getWindowEnumType(): ModalWindowsTypes {
    return ModalWindowsTypes.COMMON_ERROR_DIALOG;
  }

  getInstanceOf(type: string): IModalWindow | ISetOptions | IGetClass | null {
    switch (type) {
      case 'IModalWindow':
        return this as unknown as IModalWindow;
      case 'ISetOptions':
        return this as unknown as ISetOptions;
      case 'IGetClass':
        return this as unknown as IGetClass;
      default: return null;
    }
  }

  setOptions(options: any): void {
    options = options || {};
    this.messageKey = options.messageKey;
    this.interpolation = options.interpolation;
    this.hasDoNotShowAgainButton = options.hasDoNotShowAgainButton;
  }

  getClass(): string {
    return 'common-message-dlg';
  }
}
